// extracted by mini-css-extract-plugin
export default {"main":"AddCommonMaster_main__hU4AX","actions":"AddCommonMaster_actions__NI+HM","textarea":"AddCommonMaster_textarea__CIPg6"};